import { jsx as r, jsxs as a } from "react/jsx-runtime";
import { useMultiStyleConfig as B, AlertDialog as b, AlertDialogOverlay as j, AlertDialogContent as v, AlertDialogHeader as H, AlertDialogBody as M, AlertDialogFooter as k } from "@chakra-ui/react";
import { AlertDialogHeaderIcon as z } from "./AlertDialogHeaderIcon.mjs";
import { CloseButton as F } from "../../dataDisplay/CloseButton/CloseButton.mjs";
const w = ({
  bodyStyleProps: n,
  cancelRef: d,
  children: o,
  closeOnEsc: c = !0,
  closeOnOverlayClick: g = !0,
  "data-testid": l,
  dialogStyleProps: D,
  footer: t,
  footerStyleProps: m,
  headerStyleProps: A,
  id: f,
  isCentered: s = !1,
  isOpen: h,
  onClose: i,
  onEsc: p,
  onOverlayClick: u,
  showCloseButton: y = !0,
  status: e,
  title: x,
  ...C
}) => {
  const $ = B("Modal");
  return /* @__PURE__ */ r(
    b,
    {
      leastDestructiveRef: d,
      isOpen: h,
      onClose: i,
      closeOnEsc: c,
      closeOnOverlayClick: g,
      id: f,
      isCentered: s,
      onEsc: p,
      onOverlayClick: u,
      children: /* @__PURE__ */ r(j, { children: /* @__PURE__ */ a(
        v,
        {
          "data-testid": l,
          ...e && { "data-status": e },
          ...D,
          ...C,
          children: [
            /* @__PURE__ */ a(
              H,
              {
                "data-testid": l && `${l}-header`,
                ...e && { "data-status": e },
                ...A,
                children: [
                  e && /* @__PURE__ */ r(z, { status: e }),
                  x
                ]
              }
            ),
            y && /* @__PURE__ */ r(F, { sx: $.closeButton, "aria-label": "Close", size: "md", onClick: i }),
            o && /* @__PURE__ */ r(
              M,
              {
                "data-testid": l && `${l}-body`,
                ...e && { "data-status": e },
                ...n,
                children: o
              }
            ),
            t && /* @__PURE__ */ r(
              k,
              {
                "data-testid": l && `${l}-footer`,
                ...m,
                children: t
              }
            )
          ]
        }
      ) })
    }
  );
};
export {
  w as AlertDialog
};
